import InvoicesChart from "./InvoicesChart"
import { useEffect, useState } from "react"
import { TotalInvoiceAmounts } from "../GeneratedClients/FreeBillApi"
import { apiService } from "../apiService"
import InvoicesFacts from "./InvoicesFacts"
import { HubConnection } from "@microsoft/signalr"
import moment from "moment"
import DashboardBox from "./DashboardBox"
import DashboardSlider from "./DashboardSlider"
import getDefaultInvoiceAmountList from "./getDefaultInvoiceAmountList"
import { totalInvoiceAmountsFakeData, totalInvoiceAmountsMonthlyFakeData } from "./noContentFakeData"
import { useTranslate } from "react-admin"

interface IProps {
  connection?: HubConnection
}

const Invoices = ({connection}: IProps) => {

  const [ totalInvoiceAmounts, setTotalInvoiceAmounts ] = useState<TotalInvoiceAmounts | undefined>()
  const [ totalInvoiceAmountsMonthly, setTotalInvoiceAmountsMonthly ] = useState<TotalInvoiceAmounts[]>([])
  const [ periodInMonthes, setPeriodInMonthes ] = useState<number>(12)
  const [ noContent, setNoContent] = useState<boolean>(false)
  const [ refresh, setRefresh] = useState<boolean>(true)
  const translate = useTranslate()

  const fetchData = async () => {
    var invoiceDateGt = moment().startOf('month').subtract(periodInMonthes, "months").toISOString()
    var filter = {
      invoiceDateGt: invoiceDateGt, 
      isCanceledEq: false,
      pageSize: 100000
    }
    const {data: apiTotalInvoiceAmounts} = await apiService.InvoicesApi.getTotalInvoiceAmounts(filter)
    const {data: apiTotalInvoiceAmountsMonthly} = await apiService.InvoicesApi.getTotalInvoiceAmountsMonthly(filter)
    var lastInvoiceAmount = apiTotalInvoiceAmountsMonthly[apiTotalInvoiceAmountsMonthly.length - 1]
    var defaultList = getDefaultInvoiceAmountList(periodInMonthes, lastInvoiceAmount)
    defaultList.forEach((element, index) => {
      var invoiceAmount = apiTotalInvoiceAmountsMonthly.find(x => x.month === element.month && x.year === element.year)
      defaultList[index] = invoiceAmount??element
    })
    apiTotalInvoiceAmounts?.totalInvoices === 0 && setNoContent(true)
    setTotalInvoiceAmounts(apiTotalInvoiceAmounts?.totalInvoices === 0 ? totalInvoiceAmountsFakeData() : apiTotalInvoiceAmounts)
    setTotalInvoiceAmountsMonthly(apiTotalInvoiceAmounts?.totalInvoices === 0 ? totalInvoiceAmountsMonthlyFakeData(periodInMonthes) : defaultList)
  }

  connection?.on('InvoiceUpdated', (invoice) => {
    setRefresh(!refresh)
  })
  
  useEffect(() => {
    fetchData()
  }, [refresh, periodInMonthes])

  return (
    <DashboardBox 
      title={translate("resources.dashboard.invoices.title", {smart_count: periodInMonthes})}
      minWidth={"100%"}
      slider={
        <DashboardSlider 
          label="Monate:"
          min={2}
          max={12}
          step={1}
          setValue={setPeriodInMonthes} 
          value={periodInMonthes}
        />
      }
      noContent={noContent ? translate("resources.dashboard.invoices.noContent") : undefined}
      content={[
        <InvoicesFacts data={totalInvoiceAmounts} key={1} />,
        <InvoicesChart data={totalInvoiceAmountsMonthly} key={2} />
      ]}
    />
  )
}

export default Invoices